<template>
  <div>
    <!--字段编辑弹窗 -->
    <el-button
      type="primary"
      size="mini"
      @click="field_add_statusfunctio_filed"
    >
      新增</el-button
    >
    <br />
    <el-table
      size="mini"
      :header-cell-style="{
        background: '#eee',
        color: '#000',
        border: 0,
        fontWeight: 400,
      }"
      :data="fieldlist"
      stripe
      border
      style="width: 100%; font-weight: 400"
      height="800px"
      show-overflow-tooltip="true"
    >
      <el-table-column type="index" label="序号"> </el-table-column>
      <el-table-column prop="name" label="字段名称"> </el-table-column>
      <el-table-column prop="key" label="字段标识"> </el-table-column>
      <el-table-column label="类型" prop="label"> </el-table-column>
      <el-table-column label="默认值" show-overflow-tooltip prop="value">
        <template slot-scope="scope">
          {{
            typeof scope.row.value == "object"
              ? scope.row.value.value
              : scope.row.value
          }}
        </template>
      </el-table-column>
      <el-table-column label="长度" prop="maxlength"> </el-table-column>
      <el-table-column label="是否必填">
        <template slot-scope="scope">
          {{ scope.row.required ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="不允许重复">
        <template slot-scope="scope">
          {{ scope.row.repeat ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否显示">
        <template slot-scope="scope">
          {{ scope.row.show === false ? "否" : "是" }}
        </template>
      </el-table-column>
      <el-table-column label="范围">
        <template slot-scope="scope">
          {{ scope.row.is_range ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="前缀" prop="prefix"> </el-table-column>
      <el-table-column label="后缀" prop="suffix"> </el-table-column>
      <el-table-column label="文件上传数量" prop="uploadnum"> </el-table-column>
      <el-table-column label="所属菜单" prop="menu_name"> </el-table-column>
      <el-table-column label="排序" prop="sort"> </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <div style="display: flex; justify-content: space-around">
            <div class="btn-txt" @click="edit_field(scope.row)">编辑</div>
            <div
              class="btn-error"
              v-if="scope.row.is_delete == 0"
              @click="update_field(scope.row, 1)"
            >
              停用
            </div>
            <div class="btn-success" v-else @click="update_field(scope.row, 0)">
              启用
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--新增字段弹框-->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="38%"
      top="40px"
      append-to-body
      destroy-on-close
      :visible.sync="field_add_status"
      v-if="field_add_status"
    >
    <div style="text-align: center; padding: 20px">
        <el-button type="primary" @click="fieldsave" size="mini"
          >保 存</el-button
        >
        <el-button @click="field_add_status = false" size="mini"
          >关 闭</el-button
        >
      </div>
      <el-form size="mini" :model="fieldform" label-width="120px">
        <el-form-item required label="字段名称">
          <el-input v-model="fieldform.name" placeholder="字段名称"></el-input>
        </el-form-item>
        <el-form-item required label="字段标识">
          <el-input
            v-model="fieldform.key"
            placeholder="只能英文"
            style="width: 80%"
          ></el-input>
          <el-button type="primary" @click="fieldform.key = randomCoding(10)"
            >生成</el-button
          >
        </el-form-item>
        <el-form-item required label="字段类型">
          <el-select
            @change="selectfieldchange"
            clearable
            v-model="selectfieldchangevalue"
            placeholder="请选择"
          >
            <el-option
              v-for="item in select_fideld"
              :key="item.type"
              :label="item.name"
              :value="item.type"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件名" v-if="fieldform.type == 'formtable'">
          <el-input v-model="fieldform.file"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number
            v-model="fieldform.sort"
            label="排序"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="必填">
          <el-checkbox v-model="fieldform.required"></el-checkbox>
        </el-form-item>
        <el-form-item label="不允许重复">
          <el-checkbox v-model="fieldform.repeat"></el-checkbox>
        </el-form-item>
        <el-form-item label="是否显示">
          <el-checkbox v-model="fieldform.show"></el-checkbox>
        </el-form-item>
        <el-form-item label="编辑是否显示">
          <el-checkbox v-model="fieldform.edit_show"></el-checkbox>
        </el-form-item>
        <el-form-item
          label="前缀"
          v-if="fieldform.type == 'input' || fieldform.type == 'number'"
        >
          <el-input v-model="fieldform.prefix"></el-input>
        </el-form-item>
        <el-form-item
          label="后缀"
          v-if="fieldform.type == 'input' || fieldform.type == 'number'"
        >
          <el-input v-model="fieldform.suffix"></el-input>
        </el-form-item>
        <el-form-item
          label="最大长度"
          v-if="fieldform.type == 'input' || fieldform.type == 'number'"
        >
          <el-input type="number" v-model="fieldform.maxlength"></el-input>
        </el-form-item>
        <el-form-item
          label="范围"
          v-if="
            fieldform.type == 'date' ||
            fieldform.type == 'time' ||
            fieldform.type == 'datetime'
          "
        >
          <el-checkbox v-model="changefanwei" @change="fw_change"></el-checkbox>
        </el-form-item>
        <el-form-item
          required
          label="限制数量"
          v-if="fieldform.type == 'file' || fieldform.type == 'image'"
        >
          <el-input v-model="fieldform.uploadnum" type="number"></el-input>
        </el-form-item>
        <el-form-item
          label="选人方式"
          v-if="fieldform.type == 'user' || fieldform.type == 'department'"
        >
          <el-radio v-model="fieldform.usermode" label="radio">单选</el-radio>
          <el-radio v-model="fieldform.usermode" label="multi">多选</el-radio>
        </el-form-item>
        <el-form-item
          label="选择项"
          required
          v-if="
            fieldform.type == 'select' ||
            fieldform.type == 'radio' ||
            fieldform.type == 'checkbox'
          "
        >
          <div style="display: flex; flex-flow: wrap">
            <div
              v-for="(item, index) in fieldform.selectdata"
              style="
                margin: 2px;
                border: solid 1px #ccc;
                border-radius: 2px;
                padding: 2px 5px;
              "
              :key="index"
            >
              {{ fieldform.type == "select" ? item.label : item }}
              <span class="btn-error"
                ><i
                  class="el-icon-close"
                  @click="fieldform.selectdata.splice(index, 1)"
                ></i
              ></span>
            </div>
            <div
              class="btn-txt"
              @click="add_selectinfo"
              style="margin-left: 5px; margin-top: 5px"
            >
              添加
            </div>
          </div>
        </el-form-item>
        <el-form-item
          label="数据表单"
          v-if="fieldform.type && fieldform.type == 'dataselect'"
        >
          <el-select
            @change="selectmenuchange"
            value-key="_id"
            clearable
            v-model="fieldform.server"
            :placeholder="fieldform.server.name"
          >
            <el-option
              v-for="item in meunlist"
              :key="item._id"
              :label="item.name"
              :value="{
                name: item.name,
                _id: item._id,
                class_name: item.class_name,
                server: item.server,
              }"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="字段"
          v-if="fieldform.type && fieldform.type == 'dataselect'"
        >
          <el-select
            clearable
            value-key="_id"
            v-model="fieldform.field"
            :placeholder="fieldform.field.name"
          >
            <el-option
              v-for="item in filedlist"
              :key="item._id"
              :label="item.name"
              :value="{ key: item.key, name: item.name, _id: item._id }"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="条件"
          v-if="fieldform.type && fieldform.type == 'dataselect'"
        >
          本表字段
          <el-select
            clearable
            v-model="fieldform.condition_me"
            value-key="_id"
            placeholder="请选择"
          >
            <el-option
              v-for="item in fieldlist"
              v-if="
                item.type != 'image' &&
                item.type != 'file' &&
                item.type != 'association'
              "
              :key="item._id"
              :label="item.name"
              :value="{ key: item.key, name: item.name, _id: item._id }"
            >
            </el-option>
          </el-select>
          <b>等于</b>
          {{ fieldform.server.name }}表单字段
          <el-select
            clearable
            value-key="_id"
            v-model="fieldform.condition"
            :placeholder="fieldform.condition ? fieldform.condition.name : ''"
          >
            <el-option
              v-for="item in filedlist"
              :key="item._id"
              v-if="
                item.type != 'image' &&
                item.type != 'file' &&
                item.type != 'association'
              "
              :label="item.name"
              :value="{ key: item.key, name: item.name, _id: item._id }"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="显示关联"
          v-if="fieldform.type && fieldform.type == 'association'"
        >
          关联字段
          <el-select
            clearable
            v-model="fieldform.condition_me"
            @change="selectaccoction"
            value-key="_id"
            placeholder="请选择"
          >
            <el-option
              v-for="item in fieldlist"
              v-if="item.type == 'dataselect'"
              :key="item._id"
              :label="item.name"
              :value="{ key: item.key, name: item.name, _id: item._id }"
            >
            </el-option>
          </el-select>
          显示字段
          <el-select
            clearable
            value-key="_id"
            v-model="fieldform.condition"
            @change="selectaccoction_da"
          >
            <el-option
              v-for="item in showfield"
              :key="item._id"
              v-if="
                item.type != 'image' &&
                item.type != 'file' &&
                item.type != 'association'
              "
              :label="item.name"
              :value="{ key: item.key, name: item.name, _id: item._id }"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="默认值"
          v-if="
            fieldform.type &&
            fieldform.type != 'user' &&
            fieldform.type != 'department' &&
            fieldform.type != 'dataselect'
          "
        >
          <parser :temp="fieldform"></parser>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import u from "../../../assets/js/util.js";
import parser from "../util/parser";

export default {
  components: {
    parser,
  },
  name: "field_auth",
  props: ["moduleid", "modulename"],
  data() {
    return {
      select_fideld: [],
      meunlist: [],
      filedlist: [],
      selectfieldchangevalue: "",
      field_add_status: false,
      fieldlist: [],
      editfield: {},
      fieldform: {
        name: "",
        key: this.randomCoding(10),
        value: "",
        label: "",
        required: false,
        is_range: false,
        show: true,
        edit_show: true,
        repeat: false,
        selectdata: [],
        prefix: "",
        suffix: "",
        usermode: "radio",
        uploadnum: 1,
        sort: 0,
        maxlength: 20,
        type: "",
        server: {},
        field: {},
        condition_me: {},
        condition: {},
        eventfied: {},
        file: "",
      },
      selectfielddata: {},
      showfield: [],
      guanlianfile: {},
    };
  },
  async mounted() {
    this.fieldform.menu_id = this.moduleid;
    this.fieldform.menu_name = this.modulename;
    this.select_fideld = [
      {
        name: "文本输入框",
        type: "input",
        prefix: "",
        suffix: "",
        value: "",
        required: false,
      },
      {
        name: "密码输入框",
        type: "password",
        prefix: "",
        suffix: "",
        value: "",
        required: false,
      },
      {
        name: "数字输入框",
        type: "number",
        prefix: "",
        suffix: "",
        value: "",
        required: false,
      },
      {
        name: "自定义模板",
        type: "formtable",
        value: [],
        required: false,
        file: "",
      },
      { name: "多行文本", type: "textarea", value: "", required: false },
      {
        name: "时间",
        type: "time",
        prefix: "",
        suffix: "",
        value: "",
        required: false,
        is_range: false,
      },
      {
        name: "日期",
        type: "date",
        prefix: "",
        suffix: "",
        value: "",
        required: false,
        is_range: false,
      },
      {
        name: "日期时间",
        type: "datetime",
        prefix: "",
        suffix: "",
        value: "",
        required: false,
        is_range: false,
      },
      { name: "图片", type: "image", value: [], required: false },
      { name: "文件", type: "file", value: [], required: false },
      { name: "人员选择", type: "user", value: {}, required: false },
      { name: "部门选择", type: "department", value: {}, required: false },
      { name: "地图", type: "address", value: {}, required: false },
      {
        name: "动态下拉选",
        type: "activityselect",
        value: {},
        selectdata: [],
        key: "",
        required: false,
      },
      {
        name: "下拉选",
        type: "select",
        value: "",
        selectdata: [],
        required: false,
      },
      {
        name: "数据下拉选",
        type: "dataselect",
        value: "",
        selectdata: [],
        server: {},
        field: {},
        required: false,
      },
      {
        name: "关联显示",
        type: "association",
        value: "",
        selectdata: [],
        required: false,
      },
      {
        name: "多选",
        type: "checkbox",
        value: "",
        selectdata: [],
        required: false,
      },
      {
        name: "单选",
        type: "radio",
        value: "",
        selectdata: [],
        required: false,
      },
      { name: "登录账号", type: "login", value: {}, required: false },
      {
        name: "编号",
        type: "code",
        value: "",
        selectdata: [],
        required: false,
      },
    ];
    await this.get_field();
  },
  methods: {
    async selectaccoction_da(e) {
      if (this.guanlianfile.eventfied === undefined) {
        this.guanlianfile.eventfied = {};
      }
      this.guanlianfile.eventfied[this.fieldform.key] = e.key;
      await u.post("admin", "add_field_tab", this.guanlianfile);
    },
    selectaccoction(e) {
      this.fieldlist.forEach(async (item, index) => {
        if (item._id == e._id) {
          this.guanlianfile = item;
          this.fieldform.condition = {};
          this.showfield = await u.post("admin", "query_filed", {
            menu_id: item.server._id,
          });
          // console.log(this.showfield,'2222222dddd')
        }
      });
    },
    randomCoding(sum) {
      //创建26个字母数组
      var arr = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ];
      var idvalue = "";
      let n = sum; //这个值可以改变的，对应的生成多少个字母，根据自己需求所改
      for (var i = 0; i < n; i++) {
        idvalue += arr[Math.floor(Math.random() * 26)];
      }
      return idvalue;
    },
    async get_field() {
      this.fieldlist = await u.post("admin", "query_filed", {
        menu_id: this.moduleid,
      });
    },
    field_add_statusfunctio() {
      this.field_edit_status_field = true;
    },
    field_add_statusfunctio_filed() {
      this.reloaddata();
      this.field_add_status = true;
    },
    edit_field(e) {
      this.fieldform = e;
      this.selectfieldchangevalue = e.type;
      this.field_add_status = true;
    },
    async update_field(e, status) {
      this.fieldform = e;
      this.fieldform.is_delete = status;
      this.fieldsave();
      // await u.post("admin", "updata_field", {_id: e._id, is_delete: status})
    },
    async fieldsave(e) {
      var from = this.fieldform;
      if (!from.name) {
        u.error("字段名称不能空");
        return;
      }
      if (!from.key) {
        u.error("字段标识不能空");
        return;
      }
      if (!from.type) {
        u.error("请选择字段");
        return;
      }
      if ((from.type == "image" || from.type == "file") && !from.uploadnum) {
        u.error("请输入限制数量");
        return;
      }
      if (
        (from.type == "image" || from.type == "file") &&
        from.uploadnum > 20
      ) {
        u.error("文件单次上传不超过20张");
        return;
      }
      if (from.type == "select" && !from.selectdata.length) {
        u.error("下拉选最少选择一个");
        return;
      }
      var res = await u.post("admin", "add_field_tab", from);
      if (res !== false) {
        this.field_add_status = false;
        this.reloaddata();
        this.get_field();
      }
    },
    reloaddata() {
      this.fieldform = {
        name: "",
        key: this.randomCoding(10),
        value: "",
        label: "",
        required: false,
        is_range: false,
        show: true,
        edit_show: true,
        repeat: false,
        selectdata: [],
        changefanwei: false,
        prefix: "",
        suffix: "",
        usermode: "radio",
        uploadnum: 1,
        sort: 0,
        maxlength: 20,
        type: "",
        server: {},
        field: {},
        condition_me: {},
        condition: {},
        eventfiedkey: "",
        eventfied_mekey: "",
        file: "",
      };
      this.selectfieldchangevalue = "";
      this.fieldform.menu_id = this.moduleid;
      this.fieldform.menu_name = this.modulename;
    },
    add_selectinfo() {
      var _this = this;
      this.$prompt("请输入内容|隔开值", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(async (res) => {
          var label = res.value;
          if (label && _this.fieldform.type == "select") {
            if (label.indexOf("|") != -1) {
              var arr = label.split("|");
              if (isNaN(Number(arr[1]))) {
                _this.fieldform.selectdata.push({
                  label: arr[0],
                  value: arr[1],
                });
              } else {
                _this.fieldform.selectdata.push({
                  label: arr[0],
                  value: Number(arr[1]),
                });
              }
            } else {
              _this.fieldform.selectdata.push({
                label: label,
                value:
                  new Date().getTime() +
                  "" +
                  Math.random().toString().substring(2, 8),
              });
            }
          }
          if (
            label &&
            (_this.fieldform.type == "checkbox" ||
              _this.fieldform.type == "radio")
          ) {
            _this.fieldform.selectdata.push(label);
          }
        })
        .catch(() => {});
    },
    fw_change() {
      if (this.changefanwei) {
        this.$set(this.fieldform, "value", [
          new Date().getTime(),
          new Date().getTime(),
        ]);
      } else {
        this.$set(this.fieldform, "value", new Date().getTime());
      }
      this.fieldform.is_range = this.changefanwei;
    },
    selectfieldchange(e) {
      var selectdata = {};
      this.select_fideld.forEach((item) => {
        if (item.type == e) {
          selectdata = item;
        }
      });
      this.fieldform.label = selectdata.name;
      this.fieldform.value = selectdata.value;
      this.fieldform.required = selectdata.required;
      this.fieldform.type = selectdata.type;
      if (e == "checkbox") {
        this.fieldform.value = [];
      }
      if (selectdata.type == "dataselect") {
        //数据下拉选
        this.getmenudata();
      }
    },
    async getmenudata() {
      var list = await u.post("admin", "menu_v2query", {});
      if (list !== false) {
        this.meunlist = list;
      }
    },
    async selectmenuchange(e) {
      console.log(e);
      var list = await u.post("admin", "get_field", { id: e._id });
      if (list !== false) {
        this.filedlist = list;
      }
    },
  },
};
</script>

<style scoped>
/deep/ .el-input--mini .el-input__inner::placeholder {
  color: rgba(0, 0, 0, 0.685);
}
</style>



// WEBPACK FOOTER //
// src/page/module/admin/field_edit.vue